import { render, staticRenderFns } from "./ynd.vue?vue&type=template&id=7b40e880"
import script from "./ynd.vue?vue&type=script&lang=js"
export * from "./ynd.vue?vue&type=script&lang=js"
import style0 from "./ynd.vue?vue&type=style&index=0&id=7b40e880&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports